import jQuery from 'jquery';

export default function(){
	jQuery(function(){
		jQuery('.disable-on-click').each(function(){
			const item = jQuery(this);
			
			const form = item.parents().filter('form');
			if(form.length === 0){
				item.on('click', function(){
					item.attr('disabled', 'disabled');
				});
				
			}else{
				form.on('submit', function(){
					item.attr('disabled', 'disabled');
				});
			}
		});
	});
}